"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _v = _interopRequireDefault(require("uuid/v4"));
var _mobx = require("mobx");
var _AppConstants = _interopRequireDefault(require("../constants/AppConstants"));
var _ViewMode = _interopRequireWildcard(require("../constants/ViewMode"));
var _ServiceRegistry = _interopRequireDefault(require("../util/ServiceRegistry"));
var _Events = _interopRequireWildcard(require("../constants/Events"));
var _AppUtil = require("../util/AppUtil");
var _ApiConstants = _interopRequireDefault(require("../constants/ApiConstants"));
var _Deferred = _interopRequireDefault(require("../util/Deferred"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28;
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/**
 * Only fileName is a mandatory field.
 */
const DEFAULT_FILE_META = {
  fileName: "",
  mimeType: "application/pdf",
  fileSize: "",
  thumbnailLink: "",
  parent: {
    folderName: "",
    folderisIntegrationPresetLink: ""
  },
  modified: "",
  hasReadOnlyAccess: false
};
const APPLICATION_PDF_TYPE = "application/pdf";
let AppStore = exports.default = (_class = class AppStore {
  constructor() {
    var _window$adobe_dc_sdk$;
    _initializerDefineProperty(this, "appError", _descriptor, this);
    _initializerDefineProperty(this, "previewError", _descriptor2, this);
    _initializerDefineProperty(this, "fileInfoList", _descriptor3, this);
    _initializerDefineProperty(this, "dropinName", _descriptor4, this);
    // Handler for all API's given by Preview Drop-in
    _initializerDefineProperty(this, "previewRef", _descriptor5, this);
    // Flag to show/hide edit tools
    _initializerDefineProperty(this, "editAllowed", _descriptor6, this);
    // Flag to show/hide edit tools
    _initializerDefineProperty(this, "commentingAllowed", _descriptor7, this);
    // Boolean value to represent any unsaved PDF edits
    _initializerDefineProperty(this, "isDirty", _descriptor8, this);
    _initializerDefineProperty(this, "fileStatus", _descriptor9, this);
    _initializerDefineProperty(this, "appRenderingBlocked", _descriptor10, this);
    // Flag to show/hide header
    // In case of linearization this flag gets set to true when 1st page of linearized pdf is shown.
    // else it's set to true when full pdf is downloaded.
    _initializerDefineProperty(this, "fileLoaded", _descriptor11, this);
    _initializerDefineProperty(this, "showLoader", _descriptor12, this);
    _initializerDefineProperty(this, "progressText", _descriptor13, this);
    _initializerDefineProperty(this, "sideMenuOpen", _descriptor14, this);
    _initializerDefineProperty(this, "fileLoadingProgress", _descriptor15, this);
    _initializerDefineProperty(this, "searchOpen", _descriptor16, this);
    _initializerDefineProperty(this, "textSelectionEnabled", _descriptor17, this);
    // Instance of fileMetadata for Preview
    _initializerDefineProperty(this, "previewMetadata", _descriptor18, this);
    _initializerDefineProperty(this, "toastInfo", _descriptor19, this);
    _initializerDefineProperty(this, "inFullScreen", _descriptor20, this);
    _initializerDefineProperty(this, "userInfo", _descriptor21, this);
    _initializerDefineProperty(this, "currentViewMode", _descriptor22, this);
    _initializerDefineProperty(this, "isHidingBranding", _descriptor23, this);
    _initializerDefineProperty(this, "isToolsInactive", _descriptor24, this);
    // Always assume file is linearized. So that we can show progress spinner without percentage.
    // The moment we know file is not linearized we will start showing the percentage.
    _initializerDefineProperty(this, "isFileLinearized", _descriptor25, this);
    _initializerDefineProperty(this, "isPreviewSwitching", _descriptor26, this);
    // Flag to notify if full file has been downloaded in case of linearization only.
    this._fullFileLoaded = false;
    this.pdfMetadata = {};
    this.isAppReady = false;
    this.isPreviewRefReadyEventFired = false;
    this.isRenditionOnly = false;
    this.intl = void 0;
    this.heightInView = undefined;
    this.windowScrollListener = undefined;
    this.fullScreenIdInHUD = undefined;
    this.isOnDevice = false;
    this.isIOS = false;
    this.showViewMode = false;
    this.documentViewUpdate = {};
    this.documentViewUpdateEventData = {};
    this.preventDirtyPDF = false;
    this.appClosed = false;
    this.legalDialogOpen = false;
    // for selecting the tool by default after sign in.
    this.lastAnnotationToolClicked = undefined;
    this.linearizationWaitPromise = new _Deferred.default();
    this.isEditEnabled = false;
    this.toolsBoardsConfigPromise = new _Deferred.default();
    this.appRenderingStartedPromise = new _Deferred.default();
    this.appReadyPromise = new _Deferred.default();
    // Promise that resolves when edit worker is initialised which is prerequisite to start edit workflows
    this.editReadyPromise = (_window$adobe_dc_sdk$ = window.adobe_dc_sdk.editWorkerReady) === null || _window$adobe_dc_sdk$ === void 0 ? void 0 : _window$adobe_dc_sdk$.promise;
    this.appRenderingDonePromise = new _Deferred.default();
    this.toolsBoardConfig = {};
    this.selectedAsset = undefined;
    this.assetInfo = {};
    _initializerDefineProperty(this, "shouldLoadToolsBoardDropin", _descriptor27, this);
    // Bootstraps for Dropins
    _initializerDefineProperty(this, "bootstraps", _descriptor28, this);
    this.executeDropinPromise = new _Deferred.default();
    this.exitCallbackPromise = new _Deferred.default();
    this.secondaryHeaderToolsConfig = {};
    this.toolsBoardInitializationConfig = {};
    this.executeActionOpts = {};
    this.shouldSetAssetInfo = false;
    this.cleanupFileBufferValue = false;
    this._sendEvent = (event, data) => {
      _ServiceRegistry.default.getService("EventsService").sendEvent(event, data);
    };
    this.configStore = _ServiceRegistry.default.getService("ConfigStore");
    this.uiActionConfigStore = _ServiceRegistry.default.getService("UIActionConfigStore");
  }
  get fileMetadata() {
    return this.fileInfoList[0].metaData;
  }
  setFileLinearized(value) {
    this.isFileLinearized = value;
    this._sendEvent(_Events.default.FILE_LINEARIZATION_STATUS, {
      status: value
    });
  }
  setIsPreviewSwitching(value) {
    this.isPreviewSwitching = value;
  }
  isFullFileLoaded() {
    const isLinearizationEnabled = this.configStore.getActionConfig("preview").enableLinearization;
    return isLinearizationEnabled ? this._fullFileLoaded : this.fileLoaded;
  }
  initialize(data) {
    this.setAppClosed(false);
    if (data.config.editingIsRequired) {
      this.initEditBasedConfig(data);
    }
    this.setConfig(data.config);
    this.setHeightInView(data.heightInView);
    this.setDropinName(data.action);
    this.configStore.setActionConfig("preview", data.actionConfig);
    this.initializeFileInfoList(data.fileInfoList);
    this.setPreviewMetadata(this.fileInfoList[0]);
    this.isRenditionOnly = !this.fileInfoList[0].content;
    this.isOnDevice = (0, _AppUtil.isDeviceBrowser)();
    this.isIOS = (0, _AppUtil.isIOS)();
    if (this.isIOS) {
      this.configStore.setShowDownload(false);
      this.configStore.setShowPrint(false);
    }
    if ((0, _AppUtil.isAndroid)()) {
      this.configStore.setShowPrint(false);
    }
    this.initForPreset();
    this.setUIActionConfig();
    const shouldShowViewMode = this.isIntegration || this.isFWPreset;
    this.showViewMode = shouldShowViewMode && ((0, _AppUtil.isMobileBrowser)() || this.configStore.getActionConfig("preview").showViewMode);
    if (this.showViewMode) {
      this.currentViewMode = this.getActionConfig("preview").defaultViewMode || _ViewMode.default.CONTINUOUS;
    }
    this.isHidingBranding = this.showBrandingInHUD && this.isFWPreset && (!this.configStore.getActionConfig("preview").showPageControls || (0, _AppUtil.isMobileBrowser)());
    this.initForLinearization();
  }
  rejectPromise(code) {
    (0, _AppUtil.rejectAPIPromise)(code);
  }
  initForLinearization() {
    if (this.configStore.getActionConfig("preview").enableLinearization) {
      _ServiceRegistry.default.getService("EventsService").registerEventListener(_Events.default.PDF_VIEWER_READY, () => {
        _ServiceRegistry.default.getService("PerformanceService").setCompleteFileLoadedOn();
        this.linearizationWaitPromise.resolve();
        this._fullFileLoaded = true;
      });
    } else {
      this.linearizationWaitPromise.resolve();
    }
  }
  initForPreset() {
    if (this.isLBPreset) {
      _ServiceRegistry.default.getService("EmbedModeService").LBOpenPDFViewer(this.isIOS);
    } else if (this.isFWPreset) {
      _ServiceRegistry.default.getService("EmbedModeService").FWOpenPDFViewer();
    }
    if (this.configStore.getActionConfig("preview").enableSearchAPIs) {
      const blockSearch = event => {
        if ((event.metaKey || event.ctrlKey) && event.keyCode === 70 || event.keyCode === 114) {
          if (!this.inFullScreen) {
            event.stopImmediatePropagation();
          }
        }
      };
      document.addEventListener("keydown", blockSearch);
    }
    _ServiceRegistry.default.getService("EmbedModeService").pdfViewerOpen();
  }
  initEditBasedConfig(data) {
    const enableEdit = data.config.editingIsRequired;
    // eslint-disable-next-line no-param-reassign
    data.actionConfig = _objectSpread(_objectSpread({}, data.actionConfig), {}, {
      enableEdit
    });
    this.setShouldLoadToolsBoardDropin(data.config.toolsBoardRequired);
    this.isEditEnabled = data.config.editingIsRequired;
    // eslint-disable-next-line no-param-reassign
    data.config.toolsDropinList = [["editpdf", "side-nav"]];
  }
  setAppClosed(val) {
    this.appClosed = val;
    if (val) {
      this.setFileStatus(undefined);
      this.setIsDirty(false);
    }
  }
  setPDFMetadata(pdfMetadata) {
    this.pdfMetadata = pdfMetadata;
  }
  setConfig(config) {
    this.configStore.init(config);
    this.setShowLoader(this.getConfig().showFileLoadingProgress);
  }
  setLastAnnotationToolClicked(annotationToolId) {
    this.lastAnnotationToolClicked = annotationToolId;
  }
  setAssetInfo(value) {
    this.assetInfo = value;
  }
  setSelectedAsset(selectedAsset) {
    this.selectedAsset = selectedAsset;
  }
  setUserInfo(userInfo) {
    this.userInfo = userInfo;
  }
  setCurrentViewMode(viewMode) {
    this.currentViewMode = viewMode;
  }
  setUIActionConfig() {
    this.uiActionConfigStore.init(this.configStore.getActionConfig("preview").uiActionConfig);
  }
  getActionConfig(dropinAction) {
    return this.configStore.getActionConfig(dropinAction);
  }
  getUserInfo() {
    return this.userInfo;
  }
  getFileInfoList() {
    return this.fileInfoList;
  }
  setWindowScrollListener(listener) {
    this.windowScrollListener = listener;
  }
  setHeightInView(heightInView) {
    this.heightInView = heightInView;
    if (this.windowScrollListener) {
      const viewTop = heightInView.viewStartH;
      const viewHeight = heightInView.viewEndH - viewTop;
      const data = {
        viewTop,
        viewHeight,
        windowHeight: heightInView.winHeight
      };
      this.windowScrollListener({
        data
      });
    }
  }
  toggleLoaderWithText(show, text) {
    this.setPlainProgressText(text);
    this.setShowLoader(show);
  }
  setSecondaryHeaderToolsConfig(config) {
    this.secondaryHeaderToolsConfig = config;
  }
  setToolsBoardInitializationConfig(config) {
    this.toolsBoardInitializationConfig = config;
  }
  setInFullScreen(value) {
    if (this.inFullScreen !== value) {
      this.inFullScreen = value;
      _ServiceRegistry.default.getService("FullScreenManager").setFullScreen(value);
    }
  }
  setToastInfo(value) {
    this.toastInfo = value;
  }
  setSearchOpen(value) {
    this.searchOpen = value;
    this._sendEvent(_Events.default.SEARCH_UI_TOGGLE, {
      shown: this.searchOpen
    });
  }
  setTextSelectionEnabled(value) {
    this.textSelectionEnabled = value;
  }
  setSideMenuOpen(value) {
    this.sideMenuOpen = value;
  }
  setAppRenderingBlocked(value) {
    this.rejectPromise(_ApiConstants.default.API_RESPONSE.PREVIEW_RENDERING_FAILED);
    this.appRenderingBlocked = value;
    if (!this.getConfig().showSimpleLoader) {
      this.setShowLoader(false);
      _ServiceRegistry.default.getService("DialogApi").showBlockingDialogWithReload("FILE_PREVIEW_ERROR_TITLE", "FILE_PREVIEW_ERROR_MSG");
    }
  }
  setAppError(appError) {
    if (this.configStore.getSaveCallbackConfig().showError) {
      this.appError = appError;
    }
  }
  setPreviewError(previewError) {
    if (this.configStore.getConfig().showPreviewErrors) {
      this.previewError = previewError;
      this.setShowLoader(false);
      if (this._fileRendertimeoutRef) {
        clearTimeout(this._fileRendertimeoutRef);
      }
    }
  }
  _getFilteredFileInfo(fileInfo, index) {
    const metaData = _objectSpread(_objectSpread({}, DEFAULT_FILE_META), fileInfo.metaData);
    const newFileInfo = {
      content: fileInfo.content
    };
    newFileInfo.metaData = metaData;
    newFileInfo.metaData.fileName = newFileInfo.metaData.fileName || newFileInfo.metaData.name;
    if (fileInfo.metaData && fileInfo.metaData.type && !fileInfo.metaData.mimeType) {
      newFileInfo.metaData.mimeType = fileInfo.metaData.type;
    }
    newFileInfo.id = metaData.id ? metaData.id : `${index}:${(0, _v.default)()}`;
    if (metaData.hasReadOnlyAccess) {
      this.setEditAllowed(false);
    }
    if (fileInfo.rendition) {
      newFileInfo.rendition = fileInfo.rendition;
    }
    newFileInfo.currentState = _AppConstants.default.STATE.INITIAL;
    return newFileInfo;
  }
  initializeFileInfoList(fileInfoList) {
    const finalFileInfoList = [];
    fileInfoList.forEach((fileInfo, index) => {
      const newFileInfo = this._getFilteredFileInfo(fileInfo, index);
      finalFileInfoList.push(newFileInfo);
    });
    this.fileInfoList = finalFileInfoList;
  }
  setFileInfoList(fileInfoList) {
    this.fileInfoList = fileInfoList;
  }
  setFileMetadata(fileId, metadata) {
    this.fileInfoList = this.fileInfoList.map(fileInfo => {
      if (fileInfo.id === fileId) {
        const metaData = _objectSpread(_objectSpread({}, DEFAULT_FILE_META), metadata);
        return _objectSpread(_objectSpread({}, fileInfo), {}, {
          metaData
        });
      }
      return fileInfo;
    });
  }
  setPreviewMetadata(info) {
    this.setFileLoaded(false);
    if (info) {
      this.previewMetadata = {
        mimeType: info.metaData.mimeType,
        fileName: info.metaData.fileName,
        id: info.id,
        hasReadOnlyAccess: info.metaData.hasReadOnlyAccess || false,
        filePath: info.metaData.filePath
      };
    } else {
      this.previewMetadata = null;
    }
  }
  setFileName(fileName) {
    this.previewMetadata.fileName = fileName;
    if (this.fileInfoList.length > this.previewMetadata.id) {
      this.fileInfoList[this.previewMetadata.id].metaData.fileName = fileName;
    }
  }
  setBootstraps(bootstraps) {
    this.bootstraps = bootstraps;
  }
  setAppReady(value) {
    // App can't be set back to not ready and it can be ready only once.
    if (value && !this.isAppReady) {
      this.isAppReady = true;
      this._sendEvent(_Events.default.APP_RENDERING_DONE);
      this.appRenderingDonePromise.resolve();
    }
  }
  setPreviewRefReadyEventFired(value) {
    this.isPreviewRefReadyEventFired = value;
  }
  getFileInfoById(fileId) {
    let fInfo = null;
    this.fileInfoList.forEach(fileInfo => {
      if (fileInfo.id === fileId) {
        fInfo = fileInfo;
      }
    });
    return fInfo;
  }
  getAssetInfo() {
    return this.assetInfo;
  }
  getAppRenderingStart() {
    return this.isAppRenderingStart;
  }
  getAppReady() {
    return this.isAppReady;
  }
  setDropinName(dropinName) {
    this.dropinName = dropinName;
    if (!this.isInPreview) {
      // Going away from preview
      this.setToastInfo(null);
    }
  }

  // TODO: remove this logic
  get hideFileNameToast() {
    return this.configStore.showFullScreenModal || (0, _AppUtil.isMobileBrowser)() && (this.enableModernViewer ? this.isSizedPreset : this.isSizedPreset || this.isLBPreset);
  }

  // TODO: remove this logic
  get hideScrubberInLB() {
    return (0, _AppUtil.isMobileBrowser)() && this.isLBPreset;
  }
  get isInPreview() {
    return this.dropinName && this.dropinName.toLowerCase().indexOf("preview") === 0;
  }
  get isInEdit() {
    return this.dropinName && this.dropinName.toLowerCase().indexOf("editpdf") === 0;
  }
  get isInLinePreset() {
    return this.isInPreview && this.configStore.getActionConfig("preview").embedMode === _ViewMode.Preset.IN_LINE;
  }
  get isFWPreset() {
    return this.isInPreview && this.configStore.getActionConfig("preview").embedMode === _ViewMode.Preset.FULL_WINDOW;
  }
  get isSizedPreset() {
    return this.isInPreview && this.configStore.getActionConfig("preview").embedMode === _ViewMode.Preset.SIZED_CONTAINER;
  }
  get isLBPreset() {
    return this.isInPreview && this.configStore.getActionConfig("preview").embedMode === _ViewMode.Preset.LIGHT_BOX;
  }
  get isIntegration() {
    return this.isInPreview && this.configStore.getActionConfig("preview").embedMode === "INTEGRATION";
  }
  get isEditAllowed() {
    return this.editAllowed && !this.isRenditionOnly && !this.hasReadOnlyFile;
  }
  get hasReadOnlyFile() {
    return this.fileInfoList.filter(fileInfo => fileInfo.metaData.hasReadOnlyAccess).length > 0;
  }
  get isOnlyNonPDF() {
    return this.fileInfoList.length === 1 && this.fileInfoList[0].metaData.mimeType !== APPLICATION_PDF_TYPE;
  }
  get showToast() {
    return this.toastInfo && this.toastInfo.type && (this.toastInfo.type === _AppConstants.default.SHOW_TOAST.ERROR || this.toastInfo.data);
  }
  get enableModernViewer() {
    return this.configStore.getActionConfig("preview").enableModernViewer;
  }
  get showBrandingInHUD() {
    return this.configStore.getConfig().showBranding && (this.enableModernViewer ? this.isSizedPreset && !this.inFullScreen || this.isInLinePreset : this.isSizedPreset || this.isInLinePreset || this.isFWPreset);
  }
  get showBrandingInHeader() {
    return this.configStore.getConfig().showBranding && !this.showBrandingInHUD && !this.getActionConfig("preview").showPreviewHomeButton;
  }
  get showFullScreenModal() {
    return !this.inFullScreen && (this.configStore.showFullScreenModal || this.enableModernViewer && this.isSizedPreset && (0, _AppUtil.isMobileBrowser)() && this.fileLoaded);
  }
  setIsHidingBranding(value) {
    if (this.showBrandingInHUD) {
      this.isHidingBranding = value;
    }
  }
  setPreviewRef(ref) {
    this.previewRef = ref;
  }
  setIsDirty(bool) {
    this.isDirty = bool;
    if (!this.configStore.getConfig().showTopBar || this.isInEdit) {
      if (this.isDirty && this.fileStatus !== _AppConstants.default.FILE_PROGRESS_STATUS.SAVING) {
        this.setFileStatus(_AppConstants.default.FILE_PROGRESS_STATUS.EDITED);
      } else if (this.fileStatus === _AppConstants.default.FILE_PROGRESS_STATUS.EDITED) {
        this.setFileStatus(undefined);
      }
    }
  }
  setFileStatus(status) {
    if (this.isDirty && status === _AppConstants.default.FILE_PROGRESS_STATUS.SAVED) {
      this.fileStatus = _AppConstants.default.FILE_PROGRESS_STATUS.EDITED;
    } else {
      this.fileStatus = status;
    }
    if (!this.configStore.getConfig().showTopBar || this.isInEdit) {
      this._sendEvent(_Events.default.FILE_STATUS, {
        status: _AppConstants.default.FILE_PROGRESS_STATUS_REV[this.fileStatus]
      });
    }
  }
  setIsToolsInactive(value) {
    this.isToolsInactive = value;
  }
  setShouldLoadToolsBoardDropin(value) {
    this.shouldLoadToolsBoardDropin = value;
  }
  sendActionConfigUpdate() {
    if (!this.previewRef) {
      return;
    }
    this._sendEvent(_Events.InternalEvents.ACTION_CONFIG_UPDATE, {
      editAllowed: this.isEditAllowed,
      showDownload: this.configStore.showDownload,
      showFullScreen: this.configStore.showFullScreen,
      showPrint: this.configStore.showPrint,
      showCommentingToolbar: this.configStore.showCommentingToolbar
    });
  }
  setEditAllowed(value) {
    this.editAllowed = value;
    this.sendActionConfigUpdate();
  }
  setCommentingAllowed(value) {
    this.commentingAllowed = value;
  }
  setShowLoader(value) {
    this.showLoader = value;
  }
  setPlainProgressText(text) {
    this.progressText = text;
  }
  setFileLoadingProgress(bytesLoaded, totalBytes) {
    if (totalBytes) {
      let loaded = 0;
      if (bytesLoaded) {
        loaded = parseInt(bytesLoaded, 10);
      }
      this.fileLoadingProgress = Math.ceil(loaded / totalBytes * 100);
      this._sendEvent(_Events.InternalEvents.FILE_LOADING_PROGRESS, {
        bytesLoaded,
        totalBytes
      });
    }
    this.showFileLoadingProgress();
  }
  cleanupFileBuffer(cleanupFileBufferValue) {
    this.cleanupFileBufferValue = cleanupFileBufferValue;
  }
  showFileLoadingProgress() {
    if (this.isInPreview && !this.configStore.isThumbnailView) {
      if (this.intl) {
        let progressText = `${this.intl.formatMessage({
          id: "FILE_LOADING"
        })}`;
        progressText = this.shouldShowLoadingPercentage() ? this.intl.formatMessage({
          id: "file.loading.percentage"
        }, {
          percent: this.fileLoadingProgress
        }) : progressText;
        this.setPlainProgressText(progressText);
      }
      const config = this.getConfig();
      if (this.fileLoadingProgress > 99 && !this._fileRendertimeoutRef && !config.showSimpleLoader) {
        _ServiceRegistry.default.getService("PerformanceService").setFileDownloadCompletedOn();
        this._fileRendertimeoutRef = setTimeout(() => {
          if (!this.fileLoaded && !this.appClosed && !this.appRenderingBlocked) {
            const loggingService = _ServiceRegistry.default.getService("LoggingService");
            loggingService.error("AppStore", "Error in preview, file rendering timeout");
            this.setAppRenderingBlocked(true);
          }
        }, config.fileRenderingTimeout);
      }
    }
  }
  setFileLoaded(value, dialogOpen = false) {
    this.fileLoaded = value;
    if (value) {
      this.setShowLoader(false);
      this.setPlainProgressText("");
      if (this._fileRendertimeoutRef) {
        clearTimeout(this._fileRendertimeoutRef);
      }
    }
    this._sendEvent(_Events.InternalEvents.FILE_FIRST_PAGE_LOADING_DONE, {
      pageLoaded: value,
      dialogOpen
    });
  }
  get isHidingHeader() {
    return this.configStore.getConfig().showTopBar && (this.isInLinePreset || this.isSizedPreset || this.isLBPreset) && !this.enableModernViewer;
  }
  get isHidingHUD() {
    return this.enableModernViewer && this.isSizedPreset;
  }
  get shouldAdjustSearchUIBelowTopBar() {
    const previewConfig = this.configStore.getActionConfig("preview");
    if (!(0, _AppUtil.isMobileBrowser)()) {
      if (this.configStore.getConfig().showTopBar) {
        if (previewConfig.showAnnotationTools && this.editAllowed || this.enableModernViewer && (this.isFWPreset || this.isLBPreset)) {
          return previewConfig.adjustSearchUIBelowTopBar;
        }
      } else if (this.isSizedPreset) {
        return this.enableModernViewer && this.inFullScreen;
      }
    }
    return false;
  }
  get shouldHideAnnotationTools() {
    const previewConfig = this.getActionConfig("preview");
    const hideAnnotation = (0, _AppUtil.isMobileBrowser)() || !this.isEditAllowed || !this.configStore.showCommentingToolbar || !previewConfig.showAnnotationTools;
    return previewConfig.enableEncryptedWrite ? hideAnnotation || !this.commentingAllowed : hideAnnotation;
  }
  get isUserSignedIn() {
    return window && window.adobeIMS && window.adobeIMS.isSignedInUser();
  }
  setIntl(intl) {
    this.intl = intl;
    this.showFileLoadingProgress();
  }
  getConfig() {
    // eslint-disable-line class-methods-use-this
    return this.configStore.getConfig();
  }
  getConfigStore() {
    // eslint-disable-line class-methods-use-this
    return this.configStore;
  }
  getUIActionConfig() {
    return this.uiActionConfigStore;
  }
  getAnnotationFlag() {
    const config = this.getActionConfig("preview");
    if (config.selectivelyRenderAnnotsFlag) {
      return config.selectivelyRenderAnnotsFlag;
    }
    if (!config.showAnnotationTools) {
      return undefined;
    }
    const commentsApi = _ServiceRegistry.default.getService("CommentsApi");
    if (config.enableFormFilling && commentsApi.isFreetextEnabled()) {
      return "4293895418";
    }
    if (!config.enableFormFilling && commentsApi.isFreetextEnabled()) {
      return "4294943994";
    }
    if (config.enableFormFilling && !commentsApi.isFreetextEnabled()) {
      return "4294943998";
    }
    return "4293895422";
  }
  getLinearizationWaitPromise() {
    return this.linearizationWaitPromise.promise;
  }
  getAppRenderingStartedPromise() {
    return this.appRenderingStartedPromise.promise;
  }
  getAppReadyPromise() {
    return this.appReadyPromise.promise;
  }
  getAppRenderingDonePromise() {
    return this.appRenderingDonePromise.promise;
  }
  getEnablePDFJavaScriptOverridePromise() {
    return this.configStore.enablePDFJavaScriptOverridePromise.promise;
  }

  /**
   * Check if file loading percentage needs to be shown.
   * @returns Boolean indicating whether to show the percentage of file loading
   */
  shouldShowLoadingPercentage() {
    return !(this.getActionConfig("preview").enableLinearization && this.isFileLinearized);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "appError", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "previewError", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "fileInfoList", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dropinName", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "previewRef", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "editAllowed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "commentingAllowed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isDirty", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "fileStatus", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "appRenderingBlocked", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "fileLoaded", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "showLoader", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "progressText", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "";
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "sideMenuOpen", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "fileLoadingProgress", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "searchOpen", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "textSelectionEnabled", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "previewMetadata", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "toastInfo", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "inFullScreen", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "currentViewMode", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "isHidingBranding", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "isToolsInactive", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "isFileLinearized", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "isPreviewSwitching", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "shouldLoadToolsBoardDropin", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "bootstraps", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "setFileLinearized", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setFileLinearized"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsPreviewSwitching", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsPreviewSwitching"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUserInfo", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setUserInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCurrentViewMode", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setCurrentViewMode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setInFullScreen", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setInFullScreen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setToastInfo", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setToastInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSearchOpen", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSearchOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTextSelectionEnabled", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setTextSelectionEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSideMenuOpen", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSideMenuOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAppRenderingBlocked", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setAppRenderingBlocked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAppError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setAppError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPreviewError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setPreviewError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initializeFileInfoList", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFileInfoList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFileInfoList", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setFileInfoList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFileMetadata", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setFileMetadata"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPreviewMetadata", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setPreviewMetadata"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFileName", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setFileName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setBootstraps", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setBootstraps"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDropinName", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setDropinName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideFileNameToast", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideFileNameToast"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideScrubberInLB", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideScrubberInLB"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isInPreview", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isInPreview"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isInEdit", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isInEdit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isInLinePreset", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isInLinePreset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFWPreset", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFWPreset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSizedPreset", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSizedPreset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLBPreset", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLBPreset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isIntegration", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isIntegration"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEditAllowed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEditAllowed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasReadOnlyFile", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasReadOnlyFile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOnlyNonPDF", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOnlyNonPDF"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showToast", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showToast"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enableModernViewer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "enableModernViewer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showBrandingInHUD", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showBrandingInHUD"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showBrandingInHeader", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showBrandingInHeader"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showFullScreenModal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showFullScreenModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsHidingBranding", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsHidingBranding"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPreviewRef", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setPreviewRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsDirty", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsDirty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFileStatus", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setFileStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsToolsInactive", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsToolsInactive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShouldLoadToolsBoardDropin", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setShouldLoadToolsBoardDropin"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setEditAllowed", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setEditAllowed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCommentingAllowed", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setCommentingAllowed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowLoader", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowLoader"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPlainProgressText", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setPlainProgressText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFileLoadingProgress", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setFileLoadingProgress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cleanupFileBuffer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "cleanupFileBuffer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFileLoaded", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setFileLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isHidingHeader", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isHidingHeader"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isHidingHUD", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isHidingHUD"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shouldAdjustSearchUIBelowTopBar", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "shouldAdjustSearchUIBelowTopBar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shouldHideAnnotationTools", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "shouldHideAnnotationTools"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isUserSignedIn", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUserSignedIn"), _class.prototype)), _class);